import { defineComponent, ref } from 'vue';
import MicroPhone from '@/components/MicroPhone.vue';
import MicroVideo from '@/components/MicroVideo.vue';
import Countdown from '@/views/examination/components/Countdown.vue';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { useService } from '@kaokei/use-vue-service';
import { MediaService } from '@/services/exam/media.service';
import { CountdownService } from '@/services/countdown.service';
export default defineComponent({
  name: 'UserEnvCheckStage2',
  components: {
    MicroPhone: MicroPhone,
    MicroVideo: MicroVideo,
    Countdown: Countdown
  },
  setup: function () {
    var envCheckService = useService(EnvCheckService);
    var mediaService = useService(MediaService);
    var countdownService = useService(CountdownService);
    var ready = ref(false);
    envCheckService.startCheck().then(function () {
      ready.value = true;
    });
    return {
      envCheckService: envCheckService,
      mediaService: mediaService,
      countdownService: countdownService,
      ready: ready
    };
  }
});